import React from 'react';

import PeriodButton from './styles';

const ShiftChartButton = (props) => {
    return (
        <PeriodButton key={props.name} active={props.active} onClick={props.onPeriodButtonClick}>
            {props.name}
        </PeriodButton>
    );
};

export default ShiftChartButton;
